import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ordersApi, type OrderDashboard } from '../../api/orders';

const NAV = [
  { to: '/orders/list', label: 'Order list' },
  { to: '/orders/import', label: 'Import orders' },
  { to: '/orders/allocation', label: 'Allocation' },
  { to: '/orders/analytics', label: 'Analytics' },
  { to: '/orders/sla', label: 'SLA dashboard' },
];

export function OrderHubPage() {
  const [dashboard, setDashboard] = useState<OrderDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void ordersApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  const stats = dashboard
    ? [
        { label: 'Total orders', value: dashboard.total_orders },
        { label: 'Pending', value: dashboard.pending_orders },
        { label: 'Allocated', value: dashboard.allocated_orders },
        { label: 'Shipped', value: dashboard.shipped_orders },
        { label: 'On hold', value: dashboard.on_hold_orders },
        { label: 'SLA breached', value: dashboard.sla_breached },
      ]
    : [];

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Order Management</h1>
      <p className="mt-1 text-sm text-slate-600">Enterprise OMS — lifecycle, allocation, and workflow engine.</p>
      <nav className="mt-4 flex flex-wrap gap-3 text-sm">
        {NAV.map((l) => <Link key={l.to} to={l.to} className="text-slate-700 hover:underline">{l.label}</Link>)}
      </nav>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {stats.map((s) => (
          <div key={s.label} className="rounded-xl border bg-white p-4">
            <p className="text-sm text-slate-500">{s.label}</p>
            <p className="mt-1 text-2xl font-semibold">{String(s.value ?? 0)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
